import Button from "@/ui/button";
import { Dialog } from 'primereact/dialog';
import './modal-continue.css'
import {useEffect} from "react";

export default function ModalContinue({ title, text, visible, setVisible, dict}) {
    const {btn_continue} = dict.button
    const handleOverlayClick = (event) => {
        if (event.target.id === "info-dialog") {
            setVisible(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Escape") {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (visible) {
            document.addEventListener("mousedown", handleOverlayClick);
            document.addEventListener("keydown", handleKeyDown);
        }
        return () => {
            document.removeEventListener("mousedown", handleOverlayClick);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [visible]);

    return (
        <Dialog className="modal_continue__dialog" visible={visible} dismissableMask={true}
                onHide={() => { if (!visible) return; setVisible(false); }} >
            <div className="modal_continue__dialog_content">
                <div className="modal_continue__dialog_title">{title}</div>
                <div className="modal_continue__dialog_description">{text}</div>
                <Button onClick={() => setVisible(false)} title={btn_continue} type="account" />
            </div>
        </Dialog>
    )
}
